import React, { Component } from 'react'
import Collapsible from '../Collapsible'
import CheckBox from '../../components/CheckBox'
import { numberWithCommas } from '../../utils/stringOps'

class FilterContentType extends Component {
  contentTypeChanged = (isChecked, selectedValue) => {
    this.props.onContentTypeChanged(isChecked, selectedValue)
  }

  render () {
    const filterContentType = this.props.filterContentTypes
      .sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name))

    return (      
        <Collapsible title='Content Type' titleClassName='box-header' id='contentType' open>
          {filterContentType.length > 0 ? <>
            <div className='div-separator'>
              <CheckBox
                id='cbContentTypeAll'
                Name='cbContentTypeAll'
                Checked={this.props.selectedContentTypeIds.length === 0}
                onTickChanged={(chk, val) => this.contentTypeChanged(chk, val)}
                Value='0' text='Show All'
              />
            </div>

            {filterContentType.map(content =>
              (
                <div key={content.id} className='filter-values'>
                  <CheckBox
                    id={'cbContentType' + content.id}
                    Name={'cbContentType' + content.id}
                    Checked={this.props.selectedContentTypeIds.includes(content.id)}
                    onTickChanged={(chk, val) => this.contentTypeChanged(chk, val)}
                    Value={content.id} text={content.name}
                  />
                  <div>{content.resultCount > 9999 ? '9,999+' : numberWithCommas(content.resultCount)}</div>
                </div>
              ))}
          </> : null}
        </Collapsible>      
    )
  }
}

export default FilterContentType
